export interface ActiveRecording {
  stop: () => Promise<File>;
}

export const recordAudio: () => Promise<ActiveRecording> = () =>
  navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(stream => {
    const mediaRecorder = new MediaRecorder(stream);
    const audioChunks = [] as Blob[];

    const handleDataAvailable = (event: BlobEvent) => audioChunks.push(event.data);
    mediaRecorder.addEventListener("dataavailable", handleDataAvailable);
    mediaRecorder.start(10);

    const stop = () =>
      new Promise<File>(resolve => {
        const onStop = () => {
          resolve(new File([new Blob(audioChunks)], "temp.mp3", { type: "audio/mp3" }));
          mediaRecorder.removeEventListener("dataavailable", handleDataAvailable);
          mediaRecorder.removeEventListener("stop", onStop);
          stream.getTracks().forEach(track => track.stop());
          mediaRecorder.stream.getTracks().forEach(track => track.stop());
        };
        mediaRecorder.addEventListener("stop", onStop);
        mediaRecorder.stop();
      });

    return { stop };
  });
